import React, {Component} from 'react';
import Select from "../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';
import NumberFormat from 'react-number-format';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {deepCopyObject} from "../../../helper/helper";
import Alert from "react-s-alert";
import Select2, {Option} from "rc-select/es";
import {getExemptions} from "../../../helper/invoiceHelper";
import {validateField} from "../../../common/validation";
import {Decimal} from "decimal.js";

class LineChargeModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			addedLineCharges: [],
			addedLineKdvExemption: [],
			addedLineOtvExemption:[],
			modal: false,
			chargeCode: null,
			percentage: "0",
			perUnitAmount: "0",
			withholdingCode: null,
			kdvExemption:null,
			otvExemption:null,
			errorMessage:null,
		};
		this.isOpen = this.isOpen.bind(this);
		this.onChange = this.onChange.bind(this);
		this.addCharge = this.addCharge.bind(this);
		this.removeCharge = this.removeCharge.bind(this);
		this.setLineCharges = this.setLineCharges.bind(this);
		this.getChargeWithCode = this.getChargeWithCode.bind(this);
		this.getWithholdingPercentage = this.getWithholdingPercentage.bind(this);
		this.onChangeExemption = this.onChangeExemption.bind(this);
		this.getExemption = this.getExemption.bind(this);
		this.onChangeGvKv = this.onChangeGvKv.bind(this);


	}

	componentWillMount() {
		this.setState({
			//addedLineCharges: deepCopyObject(this.props.addedLineCharges),
			addedLineKdvExemption : this.props.addedLineKdvExemption,
			addedLineOtvExemption: this.props.addedLineOtvExemption,
			modal: this.props.modal
		});
	}

	getWithholdingPercentage(code) {
		let res = code.split("_");
		let code1 = res[0];
		let percentage1 = res[1];
		let withholdingType = this.props.withholdingTypes.find(function (withholdingType) {
			return withholdingType.code === code1 &&  withholdingType.percentage==percentage1;
		});
		return withholdingType.percentage;
	}

	onChange(e, name, index) {
		if (index || index === 0) {
			let addedLineCharges = deepCopyObject(this.state.addedLineCharges);
			if (name === "nakitTeminati" ||name === "avansMahsubu"){
				addedLineCharges[index][name] = e.value;
			}else {
				if (name === "withholdingCode") {
					let res = e.value.split("_");
					let code1 = res[0];
					addedLineCharges[index]["percentage"] = this.getWithholdingPercentage(e.value);
					addedLineCharges[index][name] = code1;
				}else{
					addedLineCharges[index][name] = e.value;
				}
			}
			this.setState({addedLineCharges});
		} else {
			if (name === "withholdingCode") {
				let res = e.value.split("_");
				let code1 = res[0];
				this.setState({[name]: code1, percentage: this.getWithholdingPercentage(e.value)});
			} else {
				this.setState({[name]: e.value});//Ekleme satırındaki seçili vergi için oran ve vergi koduset etme
			}
		}
	}

	removeCharge(index) {
		let addedLineCharges = deepCopyObject(this.state.addedLineCharges);
		addedLineCharges.splice(index, 1);
		this.setState({addedLineCharges});
	}

	addCharge(e) {
		let index = (this.state.addedLineCharges.map(function (charge) {
			return charge.taxCode.code;
		})).indexOf(this.state.chargeCode);
		let code = [];
		let charge = this.getChargeWithCode(this.state.chargeCode);
		if (index === -1) {
			this.state.addedLineCharges.map(taxCode => {
				code.push(taxCode.taxCode.code);
			});
			if((charge.code === "0003" && code.includes("0011")) || (charge.code === "0011" && code.includes("0003"))) {
				Alert.error("Gelir Vergisi Stopajı ve Kurumlar Vergisi Stopajını aynı zamanda ekleyemezsiniz.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			}else {
				if (charge.code === "9015" && (this.props.invoiceTypeCode !== "IADE" && this.props.invoiceTypeCode !== "SGK" && this.props.invoiceTypeCode !== "TEVKIFAT" )) {
					Alert.error("KDV Tevkifat vergisi içeren faturaların Türü IADE, SGK veya TEVKIFAT olmalıdır.", {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					});
				} else {
					let addedLineCharges = this.state.addedLineCharges;
					addedLineCharges.push({
						recordId: null,
						amount: 0,
						calculatedBy: charge.calculatedBy,
						direction: charge.direction,
						priority: charge.priority,
						exemptionReasonCode: null,
						percentage: (charge.calculatedBy === "AMOUNT" ? this.state.percentage : "0"),
						perUnitAmount: (charge.calculatedBy === "AMOUNT" ? "0" : this.state.perUnitAmount),
						taxCode: charge,
						invoiceLineId: null,
						withholdingCode: this.state.withholdingCode
					});
					addedLineCharges.map(charge => {
						if(charge.taxCode.code === "0003" || charge.taxCode.code === "0011"){
							charge.nakitTeminati = 0;
							charge.avansMahsubu= 0;
						}
					})
					addedLineCharges.sort((charge1, charge2) => charge1.priority - charge2.priority);
					this.setState({
						addedLineCharges: addedLineCharges,
						percentage: "0",
						perUnitAmount: "0",
						withholdingCode: null,
						chargeCode: null
					});
					console.log("addedLineCharges",addedLineCharges);
				}
			}
		} else {
			this.setState({chargeCode: null, percentage: "0", perUnitAmount: "0", withholdingCode: null});
			Alert.error(charge.shortName + ' vergisi zaten eklidir.', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}

	setLineCharges(e) {
		let error = {};
		let errorMessage = "";
		let charges = this.state.addedLineCharges;
		for (let i = 0; i < charges.length; i++) {
			if (charges[i].percentage !== "") {
				if (charges[i].taxCode.code === "9015") {
					if (this.props.invoiceTypeCode === "TEVKIFAT") {
						error.withholdingCode = validateField(undefined, "1,10", charges[i].withholdingCode);
						if (!error.withholdingCode.valid) {
							errorMessage = errorMessage + " <strong>Fatura tipi TEVKIFAT iken ve KDV TEVKİFAT Vergisi ekli iken Tevkifat Sebebi girilmelidir.</strong><br/>";
						}
					}
				} else if (charges[i].taxCode.code === "0015" &&
					((new Decimal(charges[i].percentage)).eq(new Decimal(0))) &&
					(this.props.profileId !== 'IHRACAT' && this.props.invoiceTypeCode !=='KONAKLAMAVERGISI')) {
					error.kdvExemption = validateField(undefined, "1,10", charges[i].exemptionReasonCode);
					if (!error.kdvExemption.valid) {
						errorMessage = errorMessage + " <strong>KDV Değeri Sıfır iken KDV istisna sebebi boş bırakılamaz.</strong><br/>";
					}
				} else if (charges[i].taxCode.code === "0071" && ((new Decimal(charges[i].percentage)).eq(new Decimal(0)) )) {
					error.otvExemption = validateField(undefined, "1,10", charges[i].exemptionReasonCode);
					if (!error.otvExemption.valid) {
						errorMessage = errorMessage + " <strong>ÖTV Değeri Sıfır iken ÖTV istisna sebebi boş bırakılamaz.</strong><br/>";
					}
				}
			}
		}

		if(error && errorMessage) {
			Alert.error(errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
		else {
			this.props.listener(this.state.addedLineCharges,this.state.addedLineKdvExemption);
		}
	}

	isOpen() {
		this.props.listener(this.props.addedLineCharges);
	}

	getChargeWithCode(code) {
		let charge = this.props.charges.find(function (charge) {
			return charge.code === code;
		});
		return charge;
	}

	getExemption(code) {
		let exemption = this.props.exemptions.find(function (exemption) {
			return exemption.numberCode === code;
		});
		return exemption;
	}

	onChangeExemption(e) {
		let {name, value} = e;
		let code = (name === "otvExemption" ? "0071" : "0015");
		let index = (this.state.addedLineCharges.map(function (charge) {
			return charge.taxCode.code;
		})).indexOf(code);

		if (index === -1) {
			let message = (code === "0015" ? "KDV istisnası ekleyebilmek için KDV GERCEK vergisi eklenmelidir."
				: "ÖTV istisnası ekleyebilmek için ÖTV 1.LİSTE vergisi eklenmelidir.");
			Alert.error(message, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		} else {
			let addedLineCharges = this.state.addedLineCharges;
			let addedLineKdvExemption = this.state.addedLineKdvExemption;
			let addedLineOtvExemption = this.state.addedLineOtvExemption;
			if(this.props.invoiceTypeCode !== "IHRACKAYITLI"){
				addedLineCharges[index].percentage = 0.00;
				addedLineCharges[index].amount = 0.00;
			}
			addedLineCharges[index].exemptionReasonCode = value;
			addedLineCharges[index].exemptionReason = value ? this.getExemption(value).longCode : null;

			if(name==="kdvExemption"){
				addedLineKdvExemption = { code: value };
			}
			if(name==="otvExemption"){
				addedLineOtvExemption = { code: value };
			}

			this.setState({
				[name]: value,
				addedLineCharges: addedLineCharges,
				percentage: "0",
				perUnitAmount: "0",
				withholdingCode: null,
				chargeCode: null,
				addedLineKdvExemption: addedLineKdvExemption,
				addedLineOtvExemption: addedLineOtvExemption,
			});
		}
	}

	onChangeGvKv(){

	}

	render() {
		return (
			<Modal isOpen={this.state.modal} toggle={this.isOpen} size="lg">
				<ModalHeader toggle={this.isOpen}
							 className="justify-content-center">
					<p className="text-center" style={{margin: "0px"}}>Toplu Vergi Düzenle</p>
					<p className="text-danger" style={{margin: "0px"}}>Burada yapacağınız değişiklikler tüm satırları
						etkiler.</p>
				</ModalHeader>
				<ModalBody>
					<div className="col-sm-12">
						<div className=" col-sm-12">
							<div className=" row">
								<div className=" row">
									<div className="form-group">
										<div className="col-sm-12 row " >
											<Select
												value={this.state.chargeCode}
												clearable={false}
												style={{width: '200px'}}
												placeholder="Tüm satırlara eklenecek vergiyi seçiniz"
												noResultsText="Kayıt bulunamadı."
												onChange={(e) => e && this.onChange(e, "chargeCode", undefined)}
												options={this.props.charges.filter((charge => charge.code !== "0000" && charge.code !== "SGK_PRIM" && charge.code !== "0001" && !(charge.code > "2000" && charge.code < "4000") && charge.code !== "8001_8001")).map(charge =>({
													value: charge.code,
													label: charge.shortName
												}))}
											/>
										</div>
									</div>

									{this.state.chargeCode === '9015' &&
									<div
										className={("col-sm -" + ((this.state.withholdingCode !== "650") ? "4" : "4"))}>
										<div className="form-group">
											<Select
												id="withholdingCode"
												name="withholdingCode"
												value={this.state.withholdingCode+'_'+(this.state.withholdingCode === "650" || this.state.withholdingCode === '000' ? 0 :this.state.percentage)}
												clearable={false}
												placeholder="Seçiniz..."
												style={{ marginLeft:'15px'}}
												noResultsText="Kayıt bulunamadı."
												onChange={(e) => e && this.onChange(e, "withholdingCode", undefined)}
												options={this.props.withholdingTypes.map(withholdingType => ({
													value: withholdingType.code +"_" +withholdingType.percentage,
													label: withholdingType.code + ' - ' + withholdingType.longName
												}))}
											/>
										</div>
									</div>
									}
									{(this.state.chargeCode !== '9015' || this.state.withholdingCode === "650") &&
									<div className={("col-sm-" + ((this.state.withholdingCode === "650") ? "4" : "4"))}>
										<div className="form-group">
											<NumberFormat
												value={(this.state.chargeCode ? (this.getChargeWithCode(this.state.chargeCode).calculatedBy === "AMOUNT" ? this.state.percentage : this.state.perUnitAmount) : this.state.percentage )}
												allowNegative={false}
												isNumericString={true}
												style={{ marginLeft: '14px',padding:'4px 24px 4px 5px'}}
												suffix={this.state.chargeCode ? (this.getChargeWithCode(this.state.chargeCode).calculatedBy === "AMOUNT" ? '%' : this.props.suffix) : '%'}
												thousandSeparator={'.'} decimalSeparator={','}
												displayType="input"
												isAllowed={values => {
													return (values.value === "" ? false : true);
												}}
												renderText={value => {
													value.replace(/\./g, ',')
												}}
												onValueChange={(e) => this.onChange(e, (this.state.chargeCode ? (this.getChargeWithCode(this.state.chargeCode).calculatedBy === "AMOUNT" ? "percentage" : "perUnitAmount") : "percentage"), undefined)}
												className="form-control"/>
										</div>
									</div>
									}
									<div className="col-sm-1">
										<div className="form-group">
											<button type="button" className="TekBtn ekle" style={{marginLeft:'12px'}}
													onClick={(e) => this.addCharge(e)}
													disabled={(!this.state.chargeCode || (this.state.chargeCode === "9015" ? !this.state.withholdingCode : false))}>
												Ekle
											</button>
										</div>
									</div>
								</div>
								{this.state.addedLineCharges.map((charge, j) =>
									<div className="col-sm-12 row" key={j} >
										<div className="col-sm-4 row" >
											<div className="form-group">
												<p>{this.getChargeWithCode(charge.taxCode.code).shortName + (charge.taxCode.code === "9015" ? "( " + charge.percentage + "% )" : "")}</p>
											</div>
										</div>
										{charge.taxCode.code === "9015" &&
										<div className={("col-sm-" + ((charge.withholdingCode !== "650") ? "3" : "3"))} >
											<div className="form-group">
												<Select
													id="withholdingCode"
													name="withholdingCode"
													value={charge.withholdingCode+"_" +charge.percentage}
													clearable={false}
													placeholder="Seçiniz..."
													noResultsText="Kayıt bulunamadı."
													onChange={(e) => e && this.onChange(e, "withholdingCode", j)}
													options={this.props.withholdingTypes.map(withholdingType => ({
														value: withholdingType.code +"_" +withholdingType.percentage,
														label: withholdingType.code + ' - ' + withholdingType.longName
													}))}
												/>
											</div>
										</div>
										}
										{(charge.taxCode.code !== "9015" || charge.withholdingCode === "650") &&
										<div className={("col-sm-" + ((charge.withholdingCode === "650") ? "3" : "3"))}>
											<div className="form-group">
												<div className="form-group">
													<NumberFormat
														value={(charge.calculatedBy === "AMOUNT" ? charge.percentage : charge.perUnitAmount)}
														allowNegative={false}
														suffix={charge.calculatedBy === "AMOUNT" ? '%' : this.props.suffix}
														isNumericString={true}
														thousandSeparator={'.'} decimalSeparator={','}
														displayType="input"
														isAllowed={values => {
															return (values.value === "" ? false : true);
														}}
														renderText={value => {
															value.replace(/\./g, ',')
														}}
														onValueChange={(e) => this.onChange(e, (charge.calculatedBy === "AMOUNT" ? "percentage" : "perUnitAmount"), j)}
														className="form-control"/>
												</div>
											</div>
										</div>
										}
										<div className="col-sm-1">
											<button type="button" className="Btn temizle"
													style={{background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))'}}
													onClick={(e) => this.removeCharge(j)}>
											</button>
										</div>
									</div>
								)}
							</div>
							{this.state.addedLineCharges.map((charge, j) =>
								<div className="col-sm-12 row" key={j}>
									{(charge.taxCode.code === "0003" || charge.taxCode.code === "0011" ) &&
									<div className={("col-sm-" + ((charge.withholdingCode === "650") ? "3" : "3"))}>
										<div className="col-sm-4 row">
											<div className="form-group">
												<p>Avans Mahsubu</p>
											</div>
										</div>
										<div className="form-group">
											<div className="form-group">
												<NumberFormat
													value={charge.avansMahsubu}
													allowNegative={false}
													suffix={charge.calculatedBy === "AMOUNT" ? '%' : this.props.suffix}
													isNumericString={true}
													thousandSeparator={'.'} decimalSeparator={','}
													displayType="input"
													isAllowed={values => {
														return (values.value === "" ? false : true);
													}}
													renderText={value => {
														value.replace(/\./g, ',')
													}}
													onValueChange={(e) => this.onChange(e, "avansMahsubu", j)}
													className="form-control"/>
											</div>
										</div>
									</div>
									}
									{(charge.taxCode.code === "0003" || charge.taxCode.code === "0011") &&
									<div className={("col-sm-" + ((charge.withholdingCode === "650") ? "3" : "3"))}>
										<div className="col-sm-4 row">
											<div className="form-group">
												<p>Nakit Teminatı</p>
											</div>
										</div>
										<div className="form-group">
											<div className="form-group">
												<NumberFormat
													value={charge.nakitTeminati}
													allowNegative={false}
													suffix={charge.calculatedBy === "AMOUNT" ? '%' : this.props.suffix}
													isNumericString={true}
													thousandSeparator={'.'} decimalSeparator={','}
													displayType="input"
													isAllowed={values => {
														return (values.value === "" ? false : true);
													}}
													renderText={value => {
														value.replace(/\./g, ',')
													}}
													onValueChange={(e) => this.onChange(e, "nakitTeminati", j)}
													className="form-control"/>
											</div>
										</div>
									</div>
									}
								</div>
							)}
						</div>
					</div>
					<hr/>
					<div className="row col-sm-12">
						<div className="col-md-6">
							<div className="row">
								<label className="col-md-3 col-form-label">KDV İstisna</label>
								<div className="col-md-9">
									<div className={"form-group"}>
										<Select2
											name="kdvExemption"
											id="kdvExemption"
											allowClear={true}
											disabled={this.props.invoiceTypeCode === "TEVKIFAT" || this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA" ? true : false}
											placeholder="Seçiniz..."
											value={(this.state.addedLineKdvExemption === null || this.state.addedLineKdvExemption === undefined )  ? undefined  : this.state.addedLineKdvExemption.code }
											//value={this.state.kdvExemption === null ? undefined : this.state.kdvExemption}
											style={{width: "100%"}}
											dropdownMenuStyle={{maxHeight: 200, minWidth: 200}}
											optionLabelProp="children"
											optionFilterProp="text"
											showSearch={true}
											notFoundContent="Kayıt bulunamadı"
											getPopupContainer={(node) => {
												return node.parentNode;
											}}
											onChange={(e) => this.onChangeExemption({
												value: e,
												name: "kdvExemption"
											})}>
											{!(this.props.invoiceTypeCode === "TEVKIFAT") &&
											getExemptions(this.props.exemptions, "KDV", this.props.invoiceTypeCode).map(exemption =>
												<Option text={exemption.label} value={exemption.value}
														key={exemption.value}
														title={exemption.value}>{exemption.label}</Option>
											)
											}
										</Select2>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 ">
							<div className="row">
								<label className="col-md-3 col-form-label">ÖTV İstisna</label>
								<div className="col-md-9">
									<div className={"form-group"}>
										<Select2
											name="otvExemption"
											id="otvExemption"
											allowClear={true}
											disabled={this.props.invoiceTypeCode === "TEVKIFAT" || this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA" ? true : false}
											placeholder="Seçiniz..."
											//value={this.state.otvExemption === null ? undefined : this.state.otvExemption}
											value={(this.state.addedLineOtvExemption === null || this.state.addedLineOtvExemption === undefined) ? undefined  : this.state.addedLineOtvExemption.code }
											style={{width: "100%"}}
											dropdownMenuStyle={{maxHeight: 200, minWidth: 200}}
											optionLabelProp="children"
											optionFilterProp="text"
											showSearch={true}
											notFoundContent="Kayıt bulunamadı"
											getPopupContainer={(node) => {
												return node.parentNode;
											}}
											onChange={(e) => this.onChangeExemption({
												value: e,
												name: "otvExemption"
											})}>
											{!(this.props.invoiceTypeCode === "TEVKIFAT" || this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") &&
											getExemptions(this.props.exemptions, "OTV", this.props.invoiceTypeCode).map(exemption =>
												<Option text={exemption.label} value={exemption.value}
														key={exemption.value}
														title={exemption.value}>{exemption.label}</Option>
											)
											}
										</Select2>
									</div>
								</div>
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className="col-sm-2">
					<button type="button" className="TekBtn  vazgec"
							onClick={this.isOpen}
							style={{background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))', padding:'9px 45px 9px 20px'}}>İptal
					</button>
					</div>
					<div className="col-sm-8"></div>
					<div className="col-sm-2">
					<button type="button" className="TekBtn  kaydet" style={{padding:'9px 45px 9px 20px'}}
							onClick={(e) => this.setLineCharges(e)}>Kaydet
					</button>
					</div>
				</ModalFooter>
			</Modal>
		);
	}
}

export default LineChargeModal;

